var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"login-layout-page"},[_c('HeaderToolbar',{attrs:{"renderSideIcon":false,"renderRightMenuButtons":false}}),_c('v-content',[_c('v-container',{attrs:{"fill-height":""}},[_vm._t("default")],2),_c('SnackbarNotification')],1),_c('SatFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }